import { render, staticRenderFns } from "./VgPopup.vue?vue&type=template&id=1c68e290&scoped=true&"
import script from "./VgPopup.vue?vue&type=script&lang=js&"
export * from "./VgPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c68e290",
  null
  
)

export default component.exports